import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Link from './Link';

// ====

const ArticleNav = (props) => {
  const { data } = props;

  return (
    <>
      {data && (
        <article className="row justify-content-center">
          <div className="col text-left">
            {' '}
            {data.articleData[data.articleCurrent - 1] && (
              <Link to={data.articleData[data.articleCurrent - 1].path}>
                <span aria-hidden="true" className="mr-1">
                  <FontAwesomeIcon icon={['fas', 'angle-left']} />
                </span>
                Previous article
              </Link>
            )}
          </div>

          <div className="col text-center">
            <span className="disabled">
              Article {data.articleCurrent + 1}/{data.articleData.length}
            </span>
          </div>

          <div className="col text-right">
            {data.articleData[data.articleCurrent + 1] && (
              <Link to={data.articleData[data.articleCurrent + 1].path}>
                Next article
                <span aria-hidden="true" className="ml-1">
                  <FontAwesomeIcon icon={['fas', 'angle-right']} />
                </span>
              </Link>
            )}
          </div>
        </article>
      )}
    </>
  );
};

export default ArticleNav;

// ====

ArticleNav.propTypes = {
  data: PropTypes.arrayOf,
};
ArticleNav.defaultProps = {
  data: null,
};
